import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Persiste el dispositivo emparejado entre sesiones
export const usePrinterStore = create(
  persist(
    (set) => ({
      deviceId:   null,  // ID del dispositivo guardado tras emparejar
      deviceName: null,  // Nombre legible (p.ej. "RPP02N")
      transport:  null,  // 'native' | 'usb' | 'ble' — cómo reconectar

      setPrinter: (deviceId, deviceName, transport = 'ble') =>
        set({ deviceId, deviceName, transport }),
      clearPrinter: () => set({ deviceId: null, deviceName: null, transport: null }),
    }),
    { name: 'pos_printer' }
  )
);
